import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { MenuOption } from '.';
import { alpha } from '@mui/material';

const Container = styled.li`
  display: flex;
  padding: 0.5rem 1rem;

  & > img {
    margin-right: 1rem;
    flex-shrink: 0;
  }
`;

const Badge = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  background-color: ${({ color }) => alpha(color || '#000', 0.08)};
  border-radius: 5px;
  height: 25px;
  width: 40px;
  color: ${({ color }) => color || '#fff'};
  font-size: 13px;
  font-weight: 500;
  font-family: 'Inter';
  border: 1px solid ${({ color }) => alpha(color || '#000', 0.5) || '#000'};

  svg {
    font-size: 16px;
  }
`;

const Label = styled.p`
  font-size: 14px;
  font-family: 'Inter';
  font-weight: 500;
  color: ${({ theme }) => theme.text.standard};
`;

interface Props {
  option: MenuOption;
  color?: string;
  icon: ReactNode | string;
  props: any;
}

export const Command: React.FC<Props> = ({ option, icon, props, color }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { key, ...restProps } = props;

  return (
    <Container {...restProps}>
      {icon && <Badge color={color}>{icon}</Badge>}
      <Label>{option.label}</Label>
    </Container>
  );
};
